
import { useBaseOneActions } from "../base.actionsOne";
import { contatoHistoricoEmpresaAtom } from "./ContatoHistoricoEmpresaState";

function useContatoHistoricoEmpresaActions() {
  const baseActions = useBaseOneActions('ContatoHistoricoEmpresas', contatoHistoricoEmpresaAtom);

  return {
    list: baseActions.list,
    get: baseActions.get,
    create: baseActions.create,
    update: baseActions.update,
    delete: baseActions.delete,
  }
}

export { useContatoHistoricoEmpresaActions };

